import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '@/shared/api/errors';

/**
 * Query client with the defaults this application wants.
 *
 * It is created per provider instance instead of at module scope so each test gets a
 * clean cache and nothing leaks between them.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        // Coming back to the tab asks again for what is older than `staleTime`. Víctor
        // and Ernesto keep the app open all day in a tab: without this, whatever changed
        // meanwhile (a mailbox registered in the panel, a colleague's correction) only
        // showed after a reload. Forms are safe: the line editor keeps its edits while
        // `dirty`, and a refetch with the same data keeps the same object (structural
        // sharing), so no effect runs again.
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          // A 401 or a 404 will not fix itself by asking again.
          if (error instanceof ApiError && (error.isUnauthorized || error.status === 404)) {
            return false;
          }
          return failureCount < 2;
        },
      },
    },
  });
}
